import { useQuery } from '@tanstack/react-query';
import dataService from 'services/dataService';
import { showResult } from 'infrastructure/hooks/utils';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Routes } from 'router/routes';

import { apiUrlGenerator } from '../use-api';
import { useRealTimeUpdateRunbookViewed } from './use-realtime-update-runbook-viewed';

export interface IRunbookViewedResponse {
  exists: boolean;
}

const url = 'core-2/clinics/clinics-instructions-viewed';
const queryFn = async (clinicGuid: string) => {
  const { data, error } = await dataService.getList<IRunbookViewedResponse>(
    apiUrlGenerator(url, { clinicGuid }),
  );

  if (error) {
    return Promise.reject(error);
  }

  return data;
};

interface Props {
  clinicGuid: string;
  patientGuid: string;
}

export const getRunbookViewedKey = (clinicGuid: string) => [
  'getRunbookViewed',
  clinicGuid,
];

export const useGetRunbookViewed = ({ clinicGuid, patientGuid }: Props) => {
  const location = useLocation();

  const {
    data: runbookViewed,
    isLoading,
    error,
  } = useQuery<IRunbookViewedResponse | undefined, string | undefined>({
    queryKey: getRunbookViewedKey(clinicGuid),
    queryFn: () => queryFn(clinicGuid),
    initialData: {
      exists: true,
    },
  });

  useEffect(() => {
    if (error) {
      showResult(error);
    }
  }, [error]);

  if (location.pathname === Routes.patientGuid(patientGuid)) {
    useRealTimeUpdateRunbookViewed({ isShowDataNotification: true });
  }

  return { runbookViewed, runbookViewedLoading: isLoading };
};
